
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { phoneNumberConvert } from '@/utils/util'
import BackNav from '@/components/BackNav/index.vue'

@Component({
  name: 'PersonAccountCenter',
  components: {
    BackNav
  }
})
export default class PersonAccountCenter extends Vue {
  @Getter mobile!: string
  @Getter userId!: string

  phoneNumberConvert = phoneNumberConvert

  created() {
  }

  // 点击手机号码
  onPhoneClick() {
    // this.$toast('手机号码')
    this.$router.push('/changeMobile')
  }

  // 修改密码
  onChangePassword() {
    // this.$toast('修改密码')
    this.$router.push('/changePwd')
  }

  // 店铺绑定
  onStoreBind() {
    this.$router.push({
      path: '/disBindStore',
    })
  }

  // 注销账号
  onDeleteAccount() {
    this.$router.push('/closeAccount')
  }
}
